export const getAllGames = (state) => {
  return state.games.gameIds.map((id) => state.games.gamesById[id]);
};

export const getGameById = (state, id) => {
  return state.games.gamesById[id];
};

export const getGameByUrl = (state, url) => {
  const games = getAllGames(state);

  return games.find((item) => item.friendly_url === url) || false;
};
